var $ = jQuery

export default function TextImageVideo() {
	const containersArray = [document.querySelectorAll('.mtt-text-image'), document.querySelectorAll('.mtt-text-image-cover')]

    if (containersArray.length) {
        for (let i = 0; i < containersArray.length; i++) {
            const containers = containersArray[i]
            
            if (containers.length) {
                
                for (let j = 0; j < containers.length; j++) {
                    const container = containers[j];
                    
                    new addVideoPlay(container)
                }
            }
            
        }
    }    
}

class addVideoPlay {
    constructor(container) {
        this.container = container
        this.button = this.container.querySelector('.play-btn')
        this.video = this.container.querySelector('video')

        this.onPlayClick()
    }

    onPlayClick() {        

        if (this.button) {
            this.toggleButtonClassOnEvent()

            this.button.addEventListener('click', () => {
                this.removeImage()
                this.toggleVideoPlay()                
            })            
        }
    }

    removeImage() {
        const image = this.container.querySelector('.video-image .object-fit')
        image && image.classList.add('fadeout')
    }

    toggleVideoPlay() {        

        if (this.video) {
            
            if (!this.video.src) {
                this.video.src = this.video.getAttribute('data-src')
            }   
            
            if (this.button.classList.contains('playing')) {
                this.video.pause()
            } else {
                this.video.play()
            }
        }
    }

    toggleButtonClassOnEvent() {
        this.video.onpause = () => {
            this.button.classList.remove('playing')
        }

        this.video.onplay = () => {
            this.button.classList.add('playing')
        }       
    }   
} 